<template>
    <div id="browse">
        <Navi currentPage="2-2"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Analyze</el-breadcrumb-item>
                    <el-breadcrumb-item>EMIC: causal genes inference</el-breadcrumb-item>
                    <el-breadcrumb-item>Results</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <div class="results" v-if="!error_page">
                    <div class="tip_box">
                        <i class="el-icon-warning"></i> The webpage tracks the progress and results of your job, please mark the
                        URL for checking it at anytime. The job will run about 30 minutes. The webpage will refresh automatically until the job is completed. 
                        The results page will be kept for 30 days after the job is completed.
                    </div>
                    <el-collapse v-model="activeCollapse1">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Job progress
                            </template>
                            <div class="task_progress">
                                <div class="current_status_box" >
                                   <p style="margin:0">Current status: 
                                       <span v-if="progress_num == 3" style="color:#F56C6C;font-weight:bold"><i class="el-icon-loading"></i> Queued </span> 
                                       <span v-if="progress_num == 4" style="color:#E6A23C;font-weight:bold"><i class="el-icon-loading"></i> Running </span> 
                                       <span v-if="progress_num == 5" style="color:#67C23A;font-weight:bold"><i class="el-icon-finished"></i> Completed </span> 
                                       (Last check:	{{now_time}}).
                                       <span v-if="progress_num != 5 && email!=''">You have submitted email address and you will be notified when the job is completed.</span>
                                       <span v-if="progress_num != 5 && email==''">
                                           <el-button type="text" icon="el-icon-message" @click="add_email">Notify me via email when job is completed? (optionally)</el-button>
                                        </span>
                                    </p>
                                </div>
                                <!-- <div class="current_status_box" v-if="progress_num == 4">
                                   Current status:<span style="color:#E6A23C;font-weight:bold"><i class="el-icon-loading"></i> Running </span> (Last check:	{{now_time}})
                                    {{email_info}}
                                </div>
                                <div class="current_status_box" v-if="progress_num == 5">
                                   Current status: <span style="color:#67C23A;font-weight:bold"><i class="el-icon-finished"></i> Finished </span>(Last check: {{now_time}})
                                </div> -->
                                <el-steps
                                    :space="220"
                                    :active="progress_num - 1"
                                    process-status="success"
                                    finish-status="success"
                                    :align-center="true"
                                   
                                >
                                    <el-step title="Uploaded GWAS" :description="upload_time"></el-step>
                                    <el-step title="Submitted job" :description="submit_time"></el-step>
                                    <el-step title="Queued" :description="submit_time"></el-step>
                                    <el-step title="Running" :description="run_time"></el-step>
                                    <el-step title="Completed" :description="finish_time"></el-step>
                                </el-steps>

                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="2-1" v-if="progress_num == 5">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Final status of job
                            </template>
                            <el-alert
                                v-if="status_code == 3"
                                title="Failed"
                                type="error"
                                :description="'The job is failed. Information: ' + status_msg+' Please check your GWAS file and options. In case of difficulty, please contact us on limiaoxin@mail.sysu.edu.cn (Prof. Li).'"
                                :closable="false"
                                show-icon
                            ></el-alert>
                            <el-alert
                                v-if="status_code == 4"
                                title="Success"
                                type="success"
                                description="The job ran successfully!"
                                :closable="false"
                                show-icon
                            ></el-alert>
                        </el-collapse-item>
                        <el-collapse-item name="2" >
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Summary of job
                            </template>
                            <div class="task_results">
                                <el-descriptions class="margin-top" title :column="3" border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-user"></i>
                                            Job label
                                        </template>
                                        {{ task_label }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-phone"></i>
                                            Population
                                        </template>
                                        {{ pop }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-building"></i>
                                            Reference genome version
                                        </template>
                                        {{ ref_genome }}
                                    </el-descriptions-item>

                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Chromosome column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ chr }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Position column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ bp }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            A1 column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ a1 }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            A2 column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ a2 }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            A1 frequence column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ freq_a1 }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Effect size type
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ effect_size_type }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Effect size column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ effect_size }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            SE column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ se }}</el-tag>
                                    </el-descriptions-item>                                    
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Reference eQTL tissue
                                        </template>
                                        {{ ref_eqtl }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Reference eQTL type
                                        </template>
                                        {{ ref_eqtl_type }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            P-value threshold for eQTL
                                        </template>
                                        {{ filter_eqtl_p }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            LD coefficient threshold
                                        </template>
                                        {{ ld_pruning_mr }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            P-value threshold for EMIC-PFM
                                        </template>
                                        {{emic_pfm_p}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            P-value threshold for plotting
                                        </template>
                                        {{ emic_plot_p }}
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="3" v-if="status_code == 4">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Results
                            </template>
                            <div class="result_box">
                                <el-link type="primary" :href=result_link target="_blank">Click here</el-link> to download all EMIC results. 
                                Detailed explanation of the result file is provided in the
                                <el-link type="primary" href="https://kggsee.readthedocs.io/en/latest/detailed_document.html#id7" target="_blank">KGGSEE documentation</el-link>.
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="results" v-else>
                    <el-result icon="error" title="Invalid link" :subTitle="error_msg"></el-result>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
import Bar from "@/components/plot/bar.vue";
import Tab from "@/components/plot/common_table.vue";
import CellTab from "@/components/plot/cell_table.vue";
// import SPR from "@/components/show_phenotype_result.vue";
import axios from "axios/dist/axios.min";
import { api_dir, echartTable2vxeTable, getTime } from "@/bus.js";

export default {
    name: "browse",
    components: { Navi, Footer, Box, Pie, Tab, Bar,CellTab },
    data: function () {
        return {
            error_page: true,
            loading: true,
            task_id: '',
            error_msg: "The url doesn't contain job ID! Please find your result link.",
            progress_num: 3,
            status_code: 1,
            upload_time: '',
            submit_time: '',
            run_time: '',
            finish_time: '',
            task_label: '',
            pop: '',
            ref_genome:'',
            email:'',
            chr:'',
            bp:'',
            a1:'',
            a2:'',
            freq_a1:'',
            effect_size:'',
            effect_size_type:'',
            se:'',
            ref_eqtl:'',
            ref_eqtl_type:'',
            filter_eqtl_p:'',
            ld_pruning_mr:'',
            emic_pfm_p:'',
            emic_plot_p:'',
            active_RNAdb: 'gtex',
            cell_types_des:'',
            loading1: false,
            timer: '',
            status_msg: '',
            gwas_col_type:'danger',
            now_time:'',
            result_link:'',
            activeCollapse1: ['1', '2', '2-1', '3'],
            // activeCollapse2:['1','2','3'],
            activeCollapse2: ['1'],
        };
    },
    created:function(){
        this.getTaskID();
    },
    mounted: function () {
        var _this = this;
        _this.loadData();
        this.timer = setInterval(function () {
            if (_this.progress_num == 5) {
                clearInterval(_this.timer);
            } else {
                _this.loadData();
            }
        }, 8000);

    },
    destroyed() {
        clearInterval(this.timer)
    },

    methods: {
        getTaskID() {
            if ('task_id' in this.$route.query) {
                this.task_id = this.$route.query.task_id;
            } else {
                _this.error_page = true;
            }
        },
        loadData() {
            this.now_time=getTime(Date.parse(new Date())/1000)
            var _this = this
            var methods={'0':'Beta of quantitative phenotype','1':'Log(OR) or Beta of quantitative phenotype','2':'OR of qualitative phenotype'};
            axios
                .get(api_dir + "/api.php?action=common_check_task", {
                    params: { 'task_id': _this.task_id },
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    if (res.error_code == 0) {
                        // _this.$notify({
                        //     title: "Success",
                        //     message: "Checked successfully",
                        //     type: "success",
                        //     duration: 2000,
                        // });
                        _this.status_code = res.data.status;
                        if (_this.status_code==4){
                            _this.gwas_col_type='success'
                        }
                        _this.status_msg = res.data.status_msg;
                        _this.result_link='https://pmglab.top/pcga/'+res.data.result_url
                        if ('email' in res.data){
                            _this.email=res.data['email'];
                        }
                        for (var t of ['upload_time', 'submit_time', 'run_time', 'finish_time']) {
                            _this.$data[t] = getTime(res.data[t]);
                        }
                        for (var x of ['task_label', 'pop','ref_genome','chr','bp','a1','a2','freq_a1','effect_size','se','ref_eqtl','ref_eqtl_type','filter_eqtl_p','ld_pruning_mr','emic_pfm_p','emic_plot_p']) {
                            // _this.$data[x]='';
                            if(res.data.parameter[x]!=null){
                                _this.$data[x] = res.data.parameter[x];
                            }
                        }
                        _this.$data['effect_size_type']= methods[res.data.parameter['effect_size_type']];
                        _this.progress_num = _this.getProgress(res.data.status);
                        if (_this.progress_num == 5) {
                            _this.loadGeneFullData();
                            _this.loadCellFullData();
                            _this.loadPhenotypeFullData();
                        }
                    } else {
                        _this.error_page = true;
                        _this.error_msg = "No such task_id: " + _this.task_id + ". Please check!";
                        _this.$notify({
                            title: "Illegal operation",
                            message: 'No such task_id',
                            type: "error",
                            duration: 5000,
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },
        getProgress(status) {
            let map_s = { 0: 1, 1: 3, 2: 4, 3: 5, 4: 5 };
            return map_s[status];
        },

        add_email() {
        this.$prompt('Input your email address and you will be notified when the job is complete.', 'Notify via email', {
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Incorrect email address'
        }).then(({ value }) => {
            value=value.trim();
            var _this = this
            var para = {
                'action': 'common_update_email',
                'task_id': this.task_id,
                'email': value
            }
            axios
                .get(api_dir + "/api.php", {
                    params:para
                }).then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    if(res['error_code']==0){
                        _this.$message({
                            type: 'success',
                            message: 'Successfully sumbmit your email: ' + value
                        });
                        _this.email=value;
                    }else{
                        _this.$message({
                            type: 'error',
                            message: 'Failed'
                        });
                    }
                }).catch(function(){
                    _this.$message({
                    type: 'error',
                    message: 'Failed'
                    });   
                });

        }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: 'Cancel'
        //   });       
        });
      }

    },
};
</script>



<style scoped>
.tip_box {
    padding: 15px 20px;
    background-color: #fdf6ec;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 12px;
}

/* .task_progress {
    margin-top: 20px;
} */


.task_progress >>> .el-step__title {
    font-size: 14px;
    line-height: 28px;
}
.task_progress >>> .el-step__description {
    font-size: 12px;
}
.current_status_box{
    margin-bottom: 20px;
    padding-left: 15px;
    font-size: 15px;
}

</style>

<style>
.el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
}
.el-alert__title {
    font-size: 15px;
}
.el-alert .el-alert__description {
    font-size: 14px;
}
.el-step__icon {
    height: 22px;
    width: 22px;
}
.result_box {
    font-size: 15px;
}

</style>


// WEBPACK FOOTER //
// src/views/results/common_task_emic.vue